var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"sticks",class:[_vm.bglight ? 'bg-light' : 'bg-dark', {'inline': _vm.inline}],attrs:{"shrink":"","px-3":""}},[_c('div',{staticClass:"float-ease-in"}),_c('div',{staticClass:"float-ease-in-out"})])}
var staticRenderFns = []

export { render, staticRenderFns }